import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { ActivityCardContainer, ContentWrapper } from './style';
import VideoScorm from '../VideoScorm';
import { CTA, HtmlRaw, Text } from '../../atoms';
import theme from '../../theme';
import Icon from '../../atoms/Icon';
import { Quiz } from '..';
import { withMediaQueries } from '../../../app/hoc/withMediaQueries';

const ActivityCard = ({
  mediaIsPhone,
  item = {},
  index,
  onClick,
  isActive = false,
  handleOnCompleted,
}) => {
  const { title, description, data, completion_status, code } = item;
  const [blocked, setBlocked] = useState(Object.keys(data ?? {})?.length <= 0);
  const cardRef = useRef(null);

  useEffect(() => {
    setBlocked(Object.keys(data ?? {})?.length <= 0);
  }, [data]);

  const handleOnClick = () => {
    if (blocked) return;
    if (cardRef?.current && !isActive) {
      setTimeout(() => {
        window.scrollTo(0, cardRef.current.offsetTop - 130, {
          behavior: 'smooth',
        });
      }, 100);
    }
    onClick();
  };

  return (
    <div>
      <ActivityCardContainer
        onClick={handleOnClick}
        isActive={isActive}
        blocked={blocked}
        ref={cardRef}
      >
        <div className="activity-index">{index}</div>
        <div>
          <Text type="h2" mb={8}>
            {title}
          </Text>
          <Text type="b3" color={theme().colors.placeholder}>
            {code}
          </Text>
        </div>
        <div className="status">
          {completion_status === 'completed' && (
            <Text type="b3">
              Attività completata <Icon type="check-circle" size={20} />
            </Text>
          )}
        </div>
        <div>
          {isActive ? (
            <CTA
              btnText={mediaIsPhone ? '' : 'Chiudi'}
              type="tertiary"
              icon="minus"
            />
          ) : (
            <CTA
              btnText={mediaIsPhone ? '' : 'Esplora'}
              type="tertiary"
              icon="plus"
              disabled={blocked}
            />
          )}
        </div>
        {isActive && description && (
          <div className="description">
            <Text type="h3" mb={8}>
              Descrizione attività
            </Text>
            <Text type="b3">
              <HtmlRaw html={description} />
            </Text>
          </div>
        )}
        {isActive && (
          <ContentWrapper onClick={(e) => e.stopPropagation()}>
            {item?.type === 'activity_scorm' ? (
              <VideoScorm
                selectedActivity={item}
                handleOnCompleted={handleOnCompleted}
              />
            ) : item?.type === 'activity_quiz' ? (
              <Quiz
                data={item?.data}
                handleOnCompleted={handleOnCompleted}
                activity_id={item?.id}
                duration={item?.duration}
                isCompleted={item?.completion_status === 'completed'}
              />
            ) : null}
          </ContentWrapper>
        )}
      </ActivityCardContainer>
    </div>
  );
};

ActivityCard.propTypes = {
  mediaIsPhone: PropTypes.bool,
  item: PropTypes.object,
  index: PropTypes.number,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  handleOnCompleted: PropTypes.func,
};

export default withMediaQueries(ActivityCard);
